<script>
import { notify } from '@/helpers/notify'
import { mapState } from 'vuex';
import Ability from '@/helpers/mixins/ability'

export default {
    name: 'CreatePaymentModal',
    props:[
        "data",
    ],
    mixins: [Ability],
    data() {
        return {
            form: {},
            receiptFile: null,
            paymnet_type:0,
            banks:[],
            installments: {
                installments:[],
                details:[],
                totalcount:0,
            },
            odenecek_tutar: 0,
            disableds: [],
            secili: [],
            odenen_taksitler: [],
            submitted: false,
            checked:[]
        };
    },
    computed:{
        modalTitle(){
            return this.userDetail.paymnet_type == 1 ?
            "Nakit Ödeme" : this.userDetail.paymnet_type == 2 ?
            "Kredi Kartı İle Ödeme" : this.userDetail.paymnet_type == 3 ?
            "Çek İle Ödeme" : this.userDetail.paymnet_type == 4 ?
            "Havale İle Ödeme" : this.userDetail.paymnet_type == 5 ?  "Veresiye İle Ödeme"  : "Ödeme Al"
        },
         ...mapState('userDetail', ['userDetail']),
         ...mapState('dataMove', ['dataMove']),
         odemeSekilleri(){

            let odemeler =     [
                {id:1,name:"Nakit"},
                {id:2,name:"Kredi Kartı"},
                {id:6,name:"Ödeme Linki"},
                {id:4,name:"Havale"},
                {id:3,name:"Çek"},
            ];

            const userdata = JSON.parse(localStorage.getItem('userdata'))
            if(userdata.role_name == 'admin'){
                odemeler.push( {id:5,name:"Veresiye"})
            }


            return odemeler
        }
    },
    watch:{
        secili(val){
            this.odenen_taksitler = val.map(e=> e.id)
            if(this.form.paymnet_type != 5){
                this.form.amount = val.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a.amount), 0);
            }else{
                this.form.amount = 0;
            }
        },
        userDetail:{
            handler(newVal){
                this.odenen_taksitler = []
                this.secili = []
                this.odenecek_tutar = 0;
                this.form = { amount: 0, explaine: '' }

                const { id, paymnet_type, component } = newVal
                this.form = Object.assign( {...this.form} ,{ id, paymnet_type, component })
                this.getInstallements()
                this.getBanks(this.userDetail.paymnet_type)
            },
            deep:true
        },
    },
    methods: {
		getInstallements(){

            let odenecek_tutar = 0
            const { id } = this.form

            this.$http.get(`members/${id}/getInstallments`)
            .then((response) => {
                this.installments = response.data

                response.data.details.map(e=>{
                    if(e.status != 'paid'){
                        odenecek_tutar += parseFloat(e.amount)
                    }
                })
                this.odenecek_tutar = odenecek_tutar
            });

        },
        handleSubmit(){
            if (this.submitted) return;
            this.submitted = true;

            const { id } = this.form
            // Eğer Havale ve dosya seçilmişse FormData ile gönder
            if(this.form.paymnet_type == 4 && this.receiptFile){
                let fd = new FormData();
                // ek form alanları
                for(const k in this.form){
                    fd.append(k, this.form[k]);
                }
                fd.append('odenen_taksitler', JSON.stringify(this.odenen_taksitler));
                fd.append('receipt', this.receiptFile);
                this.$http.post(`members/${id}/balances/store`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((resp) => {
                    notify.success(resp.data.message);

                    this.odenen_taksitler = []
                    this.secili = []
                    this.odenecek_tutar = 0;
                    this.form['amount'] = 0
                    this.form['explaine'] = ''
                    this.getInstallements();
                })
                .catch(() => {
                    notify.error("Bir hata oluştu!");
                })
                .finally(() => {
                    this.submitted = false;
                });
                return;
            }

            this.$http.post(`members/${id}/balances/store`, { ...this.form, odenen_taksitler: this.odenen_taksitler })
                    .then((resp) => {
                        notify.success(resp.data.message);

                        this.odenen_taksitler = []
                        this.secili = []
                        this.odenecek_tutar = 0;
                        this.form['amount'] = 0
                        this.form['explaine'] = ''
                        this.getInstallements();
                    })
                    .catch(() => {
                        notify.error("Bir hata oluştu!");
                    })
                    .finally(() => {
                        this.submitted = false;
                    });
        },

        onReceiptChange(e){
            const f = e.target.files && e.target.files[0];
            if(!f) return;
            const allowed = ['application/pdf','image/jpeg','image/jpg'];
            if(!allowed.includes(f.type)){
                notify.error('Sadece PDF veya JPG/JPEG dosya yükleyebilirsiniz.');
                e.target.value = '';
                this.receiptFile = null;
                return;
            }
            this.receiptFile = f;
        },
        getBanks(paymnet_type){
            let type= 0;

            if( paymnet_type == 2)
            type = 'banka'
            else if( paymnet_type == 3)
            type = 'cek'
            else if( paymnet_type == 4)
            type = 'havale'

            this.$http.post(`safebank`,{ output:'only', type} )
                        .then((response) => this.banks = response.data)
        },

        close(){
            this.$parent.$bvModal.hide('create_payment_modal')
        },
        paymnetChannel(e){
            this.$store.dispatch('userDetail/setUserDetailOne', { paymnet_channel :e.target.value });
        },

        dsbled(installment){
            // Seçilebilir olan taksitleri (ödenmeyen) sırala
            const selectableInstallments = this.installments.details
                .filter(inst => inst.installment_no > (this.installments.totalcount - this.installments.remaining))
                .sort((a, b) => a.installment_no - b.installment_no);

            // Mevcut taksit seçilebilir ürünler içinde var mı?
            const currentIndex = selectableInstallments.findIndex(inst => inst.installment_no === installment.installment_no);
            if (currentIndex === -1) return true;

            // Seçili değilse, sıra kuralını kontrol et
            if (!this.secili.some(inst => inst.installment_no === installment.installment_no)) {
                const selectedNums = this.secili.map(inst => inst.installment_no).sort((a, b) => a - b);

                // Hiç seçili yoksa sadece ilk taksit seçilebilir
                if (selectedNums.length === 0) {
                    return currentIndex !== 0;
                }

                const minSelected = selectedNums[0];
                const maxSelected = selectedNums[selectedNums.length - 1];

                // Min'den küçükse seçilemez
                if (installment.installment_no < minSelected) {
                    return true;
                }
                // Max'dan 2 fazlası seçilemez
                if (installment.installment_no > maxSelected + 1) {
                    return true;
                }
                // Max'dan sonraki seçilebilir
                if (installment.installment_no === maxSelected + 1) {
                    return false;
                }
                // Min ile max arasında, önceki seçili mi?
                if (installment.installment_no > minSelected && installment.installment_no <= maxSelected) {
                    return !selectedNums.includes(installment.installment_no - 1);
                }

                return false;
            } else {
                // Seçili ise, sadece son seçilen kaldırılabilir
                const lastSelected = this.secili[this.secili.length - 1];
                return installment.installment_no !== lastSelected.installment_no;
            }
        },

        createPayment( { target }){
            this.getBanks(target.value)
        },
    },
};
</script>

<template>
<b-modal id="create_payment_modal"  :title="modalTitle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row" v-if="form.component == 'onodeme' && installments && installments.remaining > 0">
            <div class="col-md-12">
                <div class="alert alert-warning">
                    Taksit sırasıyla ödenecek taksiti işaretleyiniz.
                </div>
            </div>
            <div class="col-md-12">
                <table class="table table-bordered table-hover table-sm">
                    <thead class="thead-light">
                        <tr>
                            <th colspan="3">Kalan Taksitler Tablosu</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(installment,i) in installments.details" :key="i">
                            <th style="width:10px">
                                <input
                                    v-if="installment.installment_no >(installments.totalcount - installments.remaining)"
                                    :id="`checkbox${installment.id}`"
                                    type="checkbox"
                                    v-model="secili"
                                    :value="installment"
                                    :disabled="dsbled(installment)"
                                    />
                            </th>
                            <th class="text-end ml-3">{{ installment.installment_no }} . Taksit</th>
                            <th class="text-start ml-3" style="width:50%">
                                <span v-if="installment.installment_no <= (installments.totalcount - installments.remaining)" style="text-decoration:line-through">
                                    {{ installment.amount }} TL
                                    <span class="badge rounded-pill bg-warning ms-1">Ödendi</span>
                                </span>
                                <span v-else>{{ installment.amount }} TL </span>
                            </th>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr style="background:#d7d7d7">
                            <th></th>
                            <th class="text-end ml-3">Toplam Kalan Taksit Tutarı</th>
                            <th class="text-start ml-3">{{ odenecek_tutar }} TL</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.component == 'onodeme' && !ability('dealer')">
            <label class="col-sm-5 col-form-label col-form-label" for="tur">Ödeme Türü</label>
            <div class="col">
                <select
                    class="form-select"
                    v-model="form.paymnet_type"
                    @change="createPayment($event)"

                    >
                        <option value="">Seçiniz</option>
                        <option :value="odeme.id" v-for="(odeme,i) in odemeSekilleri" :key="i">{{ odeme.name }}</option>
                </select>
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="!ability('dealer') && form.paymnet_type != 5">
            <label class="col-sm-5 col-form-label col-form-label" for="amount">Ödenen Ücret</label>
            <div class="col">
                <input
                    id="amount"
                    v-model="form.amount"
                    v-decimal
                    type="text"
                    class="form-control"
                />
                <small class="form-text text-muted">Küsratı nokta (.) olarak girilecektir. Örn: 2859.99</small>
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type == 2 || form.paymnet_type == 3 || form.paymnet_type == 4">
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-if="form.paymnet_type == 2">POS Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else-if="form.paymnet_type == 4">Havale Bankası</label>
            <label class="col-sm-5 col-form-label col-form-label" for="bank"  v-else>Çek Bankası</label>
            <div class="col">
            <select class="form-select" v-model="form.credit_card_bank" id="bank">
                <option :value="bank.id" v-for="bank in banks" :key="bank.id">{{ bank.title }} </option>
            </select>
          </div>
        </div>
                <div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type == 4">
                        <label class="col-sm-5 col-form-label" for="receipt">Dekont (PDF / JPG)</label>
                        <div class="col">
                                <input id="receipt" type="file" accept="application/pdf,image/jpeg,image/jpg" class="form-control" @change="onReceiptChange">
                        </div>
                </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="form.paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_giver_name">Çek Sahibi</label>
            <div class="col">
                <input
                id="cheque_giver_name"
                v-model="form.cheque_giver_name"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_number">Çek Numarası</label>
            <div class="col">
                <input
                id="cheque_number"
                v-model="form.cheque_number"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="row d-flex flex-wrap mb-1"  v-if="form.paymnet_type == 3">
            <label class="col-sm-5 col-form-label col-form-label" for="cheque_date">Çek Tarihi</label>
            <div class="col">
                <input
                id="cheque_date"
                v-model="form.cheque_date"
                type="date"
                class="form-control"
                />
          </div>
        </div>
        <!--<div class="row d-flex flex-wrap mb-1" v-if="form.paymnet_type != 5">
            <label class="col-sm-5 col-form-label col-form-label" for="invoice_num">Makbuz No</label>
            <div class="col">
                <input
                id="invoice_num"
                v-model="form.invoice_num"
                type="text"
                class="form-control"
                />
          </div>
        </div>-->
         <div class="row d-flex flex-wrap mb-1" v-if="!ability('dealer')">
            <label class="col-sm-5 col-form-label col-form-label" for="explaine">Açıklama</label>
            <div class="col">
                <input
                id="explaine"
                v-model="form.explaine"
                type="text"
                class="form-control"
                />
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                >Öde
            </b-button>
        </div>
    </form>
</b-modal>
</template>